import React, { Fragment, useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { t } from "i18next";
import { ScanFieldControlled } from "../../../../common/component/scan-field-controlled/scan-field-controlled";

interface IAnnounceParcelTrackerScanParcelProps {
    onParcelScanned: (value: string) => void;
    onCompleted: () => void;
    onCancel: () => void;
}

export const AnnounceParcelTrackerScanParcel = (props: IAnnounceParcelTrackerScanParcelProps) => {
    const [textValue, setTextValue] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");

    const handleValueScan = async (value?: string) => {
        const v = value ?? textValue;

        try {
            props.onParcelScanned(v);
            setErrorMessage("");
        } catch (err) {
            setErrorMessage(err.toString());
        }
    };

    return <Fragment>
        <DialogTitle>
            {t("components.parcel.btmAssignTracker.parcelScanDialog.title")}
        </DialogTitle>
        <DialogContent>
            <Typography className={"btm-tracker-announce-dialog__description"}>
                {t("components.parcel.btmAssignTracker.parcelScanDialog.description")}
            </Typography>
            <ScanFieldControlled autoFocus withAutoSubmit textValue={textValue}
                                 errorMessage={errorMessage}
                                 onTextValueChange={value => setTextValue(value)}
                                 onScan={handleValueScan}>
                <Fragment />
            </ScanFieldControlled>
        </DialogContent>
        <DialogActions>
            <Button variant={"outlined"} type={"submit"} key={"cancel-btn"}
                    onClick={async () => props.onCancel()}>
                {t("components.parcel.btmAssignTracker.parcelScanDialog.cancel")}
            </Button>
            <Button color={"secondary"}
                    variant={"contained"}
                    type={"submit"}
                    key={"submit-btn"}
                    disabled={textValue === ""}
                    onClick={() => props.onParcelScanned(textValue)}>
                {t("components.parcel.btmAssignTracker.parcelScanDialog.submit")}
            </Button>
        </DialogActions>
    </Fragment>;
};
